import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=6d1ff966&scoped=true"
import script from "./Steps.vue?vue&type=script&lang=ts"
export * from "./Steps.vue?vue&type=script&lang=ts"
import style0 from "./Steps.vue?vue&type=style&index=0&id=6d1ff966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ff966",
  null
  
)

export default component.exports